<template>
    <div>

        <div class="mainWrapper">
            <MainSideBar />

            <div class="rightContentWrapper">

                <div class="topNav">
                    <TopBarVue />
                </div>

                <div class="innerContainer">

                    <div class="theHeaderWrapper">

                        <div style="display: flex; align-items: center;">
                            <i @click="$router.go(-1)"
                                style="font-size: 25px; font-weight: bold; cursor: pointer; margin-right: 10px;"
                                class="bi bi-arrow-left"></i>

                            Site: {{ templateStore.currentSite.name }}
                        </div>


                        <div class="theRightBox">




                        </div>


                    </div>


                    <div class="siteTabWrapper">


                        <div v-for="(tabOption, index) in templateStore.siteTabOptions" :key="index" class="siteTabItem"
                            :class="{ siteTabItemSelected: tabOption.type === templateStore.currentSiteTabType }"
                            @click="templateStore.currentSiteTabType = tabOption.type">

                            {{ tabOption.name }}

                        </div>



                    </div>




                    <div v-if="templateStore.currentSiteTabType === 'members'" class="table-responsive">


                        <div class="membersHeaderWrapper">

                            <div class="theLeftBox">


                                <div style="text-align: left; font-size: 16px; margin-bottom: 15px;">
                                    <b>Members</b>
                                </div>

                                <div>

                                    <input v-if="templateStore.template_site_users.length > 0" 
                                    style="width: 300px;" type="text" 
                                    class="form-control titleInput"
                                    v-model="searchQuery"
                                    placeholder="Search users..." />

                                </div>



                            </div>

                            <div class="theRightSide">

                                <!-- <button class="btn btn-dark" type="button" style="margin-right: 10px; font-size: 13px;">
                                    <b>+ Add Group</b>
                                </button> -->

                                <button @click="templateStore.openAddUsersToSiteModalInSiteDetails" class="btn btn-dark"
                                    type="button" style="font-size: 13px;">
                                    <b>+ Add Users</b>
                                </button>

                            </div>


                        </div>



                        <div v-if="templateStore.template_site_users.length > 0">

                            <table class="table table-hover">

                                <thead>
                                    <tr>
                                        <th scope="col" class="py-3 text-start">Name</th>
                                        <!-- <th scope="col" class="py-3 text-start">Groups</th> -->
                                        <!-- <th scope="col" class="py-3 text-start">Sites</th> -->
                                        <th scope="col" class="py-3 text-start">Status</th>
                                        <th scope="col" class="py-3 text-start"></th>
                                    </tr>
                                </thead>

                                <tbody>


                                    <tr v-for="(template_site_user, index) in filteredSiteUserList"
                                        :key="index">

                                        <td class="py-3 text-start">

                                            <div v-if="template_site_user.user">
                                                {{ template_site_user.user.name }}
                                            </div>



                                        </td>

                                        <!-- <td class="py-3 text-start">

            asds

        </td> -->

                                        <!-- <td class="py-3 text-start">

            asds

        </td> -->

                                        <td class="py-3 text-start">

                                            <div v-if="template_site_user.template_inspection_normal_user">

                                                <span
                                                    v-if="template_site_user.template_inspection_normal_user.is_activated === 'yes'"
                                                    class="badge bg-success">Active</span>
                                                <span
                                                    v-if="template_site_user.template_inspection_normal_user.is_activated === 'no'"
                                                    class="badge bg-light text-dark">Deactivated</span>

                                            </div>

                                        </td>

                                        <td style="width: 100px;">

                                            <div class="iconsRow">

                                                <div v-if="template_site_user.template_inspection_normal_user">

                                                    <router-link class="linkStyle" :to="{ name: 'ViewAInspectionUser', 
                                                params: { template_inspection_normal_user_uuid: template_site_user.template_inspection_normal_user.uuid } }">
                                                
                                                    <i class="bi bi-eye theActionIcon"></i>

                                                </router-link>

                                                </div>
                                                
                                            

                                                

                                                <i @click="templateStore.setUserAndOpenRemoveUserInSiteDetails(template_site_user.user)"
                                                    class="bi bi-trash theActionIcon"></i>


                                            </div>





                                        </td>


                                    </tr>



                                </tbody>

                            </table>

                        </div>

                        <div v-else style="margin-top: 50px;">
                            No users added to this site yet. 
                        </div>



                    </div>

                    <div v-if="templateStore.currentSiteTabType === 'inspections'" class="table-responsive">


                        <div class="inspectionsHeaderWrapper">

                            <div class="theLeftBox">


                                <div style="text-align: left; font-size: 16px; margin-bottom: 15px;">
                                    <b>Inspections</b>
                                </div>

                                <div>

                                    <input style="width: 300px;" type="text" class="form-control titleInput"
                                        placeholder="Search..." />

                                </div>



                            </div>

                            <div class="theRightSide">



                            </div>


                        </div>


                        <table class="table table-hover">

                            <thead>
                                <tr>
                                    <th scope="col" class="py-3 text-start">Inspection</th>
                                    <th scope="col" class="py-3 text-start">Actions</th>
                                    <th scope="col" class="py-3 text-start">Score</th>
                                    <th scope="col" class="py-3 text-start">Conducted</th>
                                    <th scope="col" class="py-3 text-start">Completed</th>
                                    <th scope="col" class="py-3 text-start"></th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="(index) in 100" :key="index">

                                    <td class="py-3 text-start">

                                        sdfsdf

                                    </td>

                                    <td class="py-3 text-start">

                                        sdf

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td>

                                        <div class="viewReportBtn">View Report</div>




                                    </td>


                                </tr>

                            </tbody>

                        </table>



                    </div>

                    <div v-if="templateStore.currentSiteTabType === 'actions'" class="table-responsive">

                        <div class="actionsHeaderWrapper">

                            <div class="theLeftBox">


                                <div style="text-align: left; font-size: 16px; margin-bottom: 15px;">
                                    <b>Actions</b>
                                </div>

                                <div>

                                    <input style="width: 300px;" type="text" class="form-control titleInput"
                                        placeholder="Search..." />

                                </div>



                            </div>

                            <div class="theRightSide">



                            </div>


                        </div>


                        <table class="table table-hover">

                            <thead>
                                <tr>
                                    <th scope="col" class="py-3 text-start">Action</th>
                                    <th scope="col" class="py-3 text-start">Assigned To</th>
                                    <th scope="col" class="py-3 text-start">Due Date</th>
                                    <th scope="col" class="py-3 text-start">Priority</th>
                                    <th scope="col" class="py-3 text-start">Status</th>
                                    <th scope="col" class="py-3 text-start">Last Updated</th>
                                    <th scope="col" class="py-3 text-start"></th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="(index) in 100" :key="index">

                                    <td class="py-3 text-start">

                                        sdfsdf

                                    </td>

                                    <td class="py-3 text-start">

                                        sdf

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td>

                                        <div class="viewReportBtn">View Action</div>




                                    </td>


                                </tr>

                            </tbody>

                        </table>


                    </div>

                    <div v-if="templateStore.currentSiteTabType === 'issues'" class="table-responsive">

                        <div class="issuesHeaderWrapper">

                            <div class="theLeftBox">


                                <div style="text-align: left; font-size: 16px; margin-bottom: 15px;">
                                    <b>Issues</b>
                                </div>

                                <div>

                                    <input style="width: 300px;" type="text" class="form-control titleInput"
                                        placeholder="Search..." />

                                </div>



                            </div>

                            <div class="theRightSide">



                            </div>


                        </div>

                        <table class="table table-hover">

                            <thead>
                                <tr>
                                    <th scope="col" class="py-3 text-start">Issue</th>
                                    <th scope="col" class="py-3 text-start">Assigned To</th>
                                    <th scope="col" class="py-3 text-start">Due Date</th>
                                    <th scope="col" class="py-3 text-start">Priority</th>
                                    <th scope="col" class="py-3 text-start">Status</th>
                                    <th scope="col" class="py-3 text-start">Last Updated</th>
                                    <th scope="col" class="py-3 text-start">Category</th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="(index) in 100" :key="index">

                                    <td class="py-3 text-start">

                                        sdfsdf

                                    </td>

                                    <td class="py-3 text-start">

                                        sdf

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">
                                        asds
                                    </td>





                                </tr>

                            </tbody>

                        </table>

                    </div>


                    <div v-if="templateStore.currentSiteTabType === 'assets'" class="table-responsive">


                        <div class="membersHeaderWrapper">

                            <div class="theLeftBox">


                                <div style="text-align: left; font-size: 16px; margin-bottom: 15px;">
                                    <b>Assets</b>
                                </div>

                                <div>

                                    <input style="width: 300px;" type="text" class="form-control titleInput"
                                        placeholder="Search users..." />

                                </div>



                            </div>

                            <div class="theRightSide">




                            </div>


                        </div>


                        <table class="table table-hover">

                            <thead>
                                <tr>
                                    <th scope="col" class="py-3 text-start">Unique ID</th>
                                    <th scope="col" class="py-3 text-start">Display Name</th>
                                    <th scope="col" class="py-3 text-start">Type</th>
                                    <th scope="col" class="py-3 text-start">Last Inspection Date</th>
                                    <th scope="col" class="py-3 text-start">Open Actions</th>
                                    <th scope="col" class="py-3 text-start"></th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="(index) in 100" :key="index">

                                    <td class="py-3 text-start">

                                        sdfsdf

                                    </td>

                                    <td class="py-3 text-start">

                                        sdf

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        asds

                                    </td>

                                    <td class="py-3 text-start">

                                        <button class="startInspectionBtn">Start Inspection</button>

                                    </td>



                                </tr>

                            </tbody>

                        </table>


                    </div>

                    <div v-if="templateStore.currentSiteTabType === 'details'" class="table-responsive">

                        <div class="detailsHeaderWrapper">

                            <div class="theLeftBox">


                                <div style="text-align: left; font-size: 19px; margin-bottom: 15px;">
                                    <b>Site Detail</b>
                                </div>


                            </div>

                            <div class="theRightSide">



                            </div>


                        </div>



                        <div class="boxItem">

                            <div class="theLefty">

                                <div class="theNameArea">
                                    <b>Name</b>
                                </div>

                                <div class="theNameArea">
                                    Miami
                                </div>

                            </div>

                            <div class="theRighty">


                                <i class="bi bi-pencil theActionIcon"></i>

                            </div>

                        </div>

                        <div class="boxItem">

                            <div class="theLefty">

                                <div class="theNameArea">
                                    <b>Site ID</b>
                                </div>

                                <div class="theNameArea">
                                    851872e6-3dd2-48b2-acae-4cd83c617917
                                </div>

                            </div>

                            <div class="theRighty">




                            </div>

                        </div>



                    </div>




                </div>


            </div>
        </div>





        <div v-if="templateStore.showAddUsersToSiteModalInSiteDetails" class="modal-overlay">

            <div class="modal-box" style="width: 700px">

                <div class="model-box-header">
                    <div style="font-size: 17px">
                        <b>Select Users</b>
                    </div>

                    <div>
                        <i @click="templateStore.closeAddUsersToSiteModalInSiteDetails" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>

                <div class="modal-search-box" style="padding: 12px;">

                    <input v-model="searchQuery" type="text" class="form-control titleInput" placeholder="Search..." />

                </div>

                <div class="modal-content">


                    <!-- {{ templateStore.usersNotInThisSite }} -->

                    <!-- {{ templateStore.usersToAddToASite }} -->


                    <div class="innerBox">

                        <div v-if="templateStore.usersNotInThisSite.length > 0">

                            <div class="talkItem" v-for="(siteUser, index) in filteredSiteUsers"
                                :key="index" @click="templateStore.addThisUserToASite(siteUser)">



                                <div class="talkLeft">

                                    <div class="talkTitle">

                                        <div v-if="siteUser.user">

                                            {{ siteUser.user.name }}

                                        </div>

                                    </div>




                                </div>

                                <div class="talkRight">





                                    <div v-if="siteUser.is_checked" class="form-check form-switch">
                                        <input class="form-check-input theInputSwitch" type="checkbox"
                                            id="flexSwitchCheckDefault" checked>
                                    </div>

                                    <div v-else class="form-check form-switch">
                                        <input class="form-check-input theInputSwitch" type="checkbox"
                                            id="flexSwitchCheckDefault">
                                    </div>



                                </div>




                            </div>

                        </div>

                        <div v-else>
                            All users already added to this site.
                        </div>




                    </div>

                    <div class="groupActionBox" style="margin-top: 30px;">


                        <button @click="templateStore.closeAddUsersToSiteModalInSiteDetails"
                            class="btn btn-light">Cancel</button>

                        <button v-if="templateStore.isLoading" class="btn btn-dark"><b>Updating</b></button>
                        <button @click="templateStore.addTheseUsersToSite" class="btn btn-dark"><b>Add
                                Users</b></button>


                    </div>





                </div>
            </div>
        </div>


        <div v-if="templateStore.showRemoveUserInSiteDetails" class="modal-overlay">

            <div class="modal-box" style="width: 500px">

                <div class="model-box-header">
                    <div style="font-size: 17px">
                        <b>Removing {{ templateStore.currentUser.name }}?</b>
                    </div>

                    <div>
                        <i @click="templateStore.closeRemoveUserInSiteDetails" class="bi bi-x-lg"
                            style="font-size: 20px; cursor: pointer"></i>
                    </div>
                </div>



                <div class="modal-content">


                    <div style="font-size: 16px; text-align: left;">
                        Are you sure you want to remove {{ templateStore.currentUser.name }} from this site?
                    </div>


                    <div class="groupActionBox" style="margin-top: 30px;">


                        <button @click="templateStore.closeRemoveUserInSiteDetails"
                            class="btn btn-light">Cancel</button>

                        <button v-if="templateStore.isLoading" class="btn btn-dark"><b>Updating</b></button>
                        <button @click="templateStore.removeThisUserFromSite()"
                            class="btn btn-dark"><b>Save</b></button>


                    </div>





                </div>
            </div>
        </div>





    </div>
</template>

<script setup>
import MainSideBar from "@/components/Inspections/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { onMounted, defineProps, ref, computed } from 'vue';
import { useTemplateStore } from "@/stores/TemplateStore";


const templateStore = useTemplateStore();

const searchQuery = ref('');

const filteredSiteUsers = computed(() => {
  return templateStore.usersNotInThisSite.filter(siteUser =>
    siteUser?.user && 
    siteUser.user.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  ) || [];
});

const filteredSiteUserList = computed(() => {
  return templateStore.template_site_users.filter(siteUser =>
    siteUser?.user && 
    siteUser.user.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  ) || [];
});



const props = defineProps({
    uuid: String
})




onMounted(() => {

    templateStore.fetchASiteDetails(props.uuid)

})



</script>

<style scoped>
.mainWrapper {
    /* background-color: aliceblue; */
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.rightContentWrapper {
    /* overflow-y: auto; */
    width: 83%;
    display: flex;
    flex-direction: column;
}

.contentContainer {
    /* overflow-y: auto; */
    background-color: rgb(208, 28, 55);
    /* margin: 30px; */
    margin-top: 100px;
}

.rightColumns {
    /* display: flex;
  flex-direction: column; */
}

.topNav {
    background-color: blue;
}

.innerContainer {
    /* margin-top: 200px; */
    /* background-color: blueviolet; */
    overflow-y: auto;
    padding-top: 30px;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 100px;
}

.theHeaderWrapper {
    display: flex;
    justify-content: space-between;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    /* background-color: aqua; */
}

.searchBarWrapper {
    margin-top: 15px;
    width: 100%;
    padding-bottom: 20px;
    /* background-color: rgb(22, 166, 37); */
}

.theBar {
    width: 350px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
}

.button-6 {
    align-items: center;
    /* background-color: #FFFFFF; */
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
    box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
    display: inline-flex;
    font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    font-size: 16px;
    font-weight: 600;
    justify-content: center;
    line-height: 1.25;
    margin: 0;
    min-height: 3rem;
    padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
    position: relative;
    text-decoration: none;
    transition: all 250ms;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: baseline;
    width: auto;
}

.button-6:hover,
.button-6:focus {
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
    color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
    transform: translateY(-1px);
}

.button-6:active {
    background-color: #f0f0f1;
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
    color: rgba(0, 0, 0, 0.65);
    transform: translateY(0);
}

.tableWrapper {
    margin-top: 20px;
    /* background-color: aqua; */
    width: 100%;
}

.my-custom-table tbody tr td {
    padding-top: 20px;
    /* Adjust the value as needed */
    padding-bottom: 20px;
    /* Adjust the value as needed */
}

.my-custom-table th {
    padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
    text-align: left;
    /* Aligns text to the left */
    padding-left: 20px;
    padding-right: 20px;
}

.campName {
    text-decoration: none;
    color: inherit;
}

.campName:hover {
    color: rgb(10, 159, 92);
    cursor: pointer;
    text-decoration: none;
}

.iconsRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.theActionIcon {
    font-weight: bolder;
    font-size: 18px;
    color: rgb(5, 2, 2);
    cursor: pointer;
}

.theActionIcon:hover {
    cursor: pointer;
    color: rgb(30, 158, 30);
    scale: 1.3;
    transition: 1s;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
    z-index: 999;
    /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
    background-color: white;
    width: 1100px;
    padding: 20px;
    border-radius: 2px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
    text-align: center;
}

.model-box-header {
    display: flex;
    justify-content: space-between;
    /* background-color: antiquewhite; */
    height: 40px;
    margin-bottom: 15px;
}

.form-control {
    background-color: rgb(243, 246, 246);
}

.createBTN {
    width: 100%;
    margin-top: 20px;
}

.noTeamBox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    width: 100%;
}

.noMatchBox {
    background-color: red;
    width: 100%;
}

.loadMoreBtn {
    background-color: black;
    border-radius: 10px;
}

.inviteInput {
    width: 500px;
    font-size: 13px;
    cursor: pointer;
}

.tabsWrapper {
    display: flex;
    width: 100%;
    /* background-color: #a9baba; */
}


.tabItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #fdfdfd;
    padding: 30px;
    border: 1.5px solid #c3d4cb;
    cursor: pointer;
    margin: 10px;
    border-radius: 10px;
}

.tabItem:hover {

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #fdfdfd;
    padding: 30px;
    border: 1.5px solid #c3d4cb;
    cursor: pointer;
    margin: 10px;
    border-radius: 10px;
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);

}

.tabItemSelected {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    padding: 30px;
    border: 1.5px solid #c3d4cb;
    cursor: pointer;
    margin: 10px;
    border-radius: 10px;
}



.iconDrop {
    cursor: pointer;
}

.button-13 {
    background-color: #fff;
    border: 1px solid #d5d9d9;
    border-radius: 8px;
    box-shadow: rgba(213, 217, 217, 0.5) 0 2px 5px 0;
    box-sizing: border-box;
    color: #0f1111;
    cursor: pointer;
    display: inline-block;
    font-family: "Amazon Ember", sans-serif;
    font-size: 13px;
    line-height: 29px;
    padding: 0 10px 0 11px;
    position: relative;
    text-align: center;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: middle;
    min-width: 100px;
}

.button-13:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.emptyTableBox {
    margin-top: 100px;
}


.groupBtn {
    border: none;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    border-radius: 15px;
    font-size: 15px;
    margin-right: 25px;
    padding: 5px;
    padding-left: 20px;
    padding-right: 20px;
}

.groupBtn:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.theRightBox {
    display: flex;
    /* background-color: gray; */
}

.dropdown-item:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    color: black;
}


.theSearchBox {
    width: 100%;
    /* background-color: rgb(255, 136, 0); */
    padding-bottom: 20px
}

.theTableBox {
    width: 100%;
    overflow-y: auto;
    height: 500px;

}



.addUsersBox {
    /* background-color: green; */
    width: 100%;
    padding-top: 20px;

}


.theTableWrapper {
    width: 100%;
    /* background-color: yellow; */
    margin-top: 40px;
}

.selectSupBox {
    display: flex;
    width: 100%;
    border-radius: 7px;
    padding: 10px;
    max-height: 100px;
    overflow-y: auto;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    cursor: pointer;
    background-color: #f2f2f2;
}

.theSupPill {
    margin: 7px
}



.innerBox {
    /* background-color: red; */
    overflow-y: auto;
    width: 100%;
    height: 500px;
    padding: 12px;
}


.talkItem {
    display: flex;
    flex-direction: row;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
    margin-bottom: 25px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
}

.talkItem:hover {
    background-color: rgb(249, 253, 252);
}

.talkLeft {
    display: flex;
    flex-direction: column;
    padding: 5px;
    width: 80%;
    /* background-color: #aadada; */
}

.talkRight {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    /* padding: 10px; */
    /* background-color: #3ddbdb; */
}

.talkTitle {
    /* background-color: #d9e7ff; */
    text-align: left;
    font-weight: bold;
    padding: 6px;
}


.groupActionBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* background-color: gray; */
}

.siteTabWrapper {
    display: flex;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
}



.siteTabItem {
    width: 150px;
    font-size: 13px;
    font-weight: bold;
    /* background-color: gray; */
    padding: 5px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    cursor: pointer;
}

.siteTabItemSelected {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    width: 150px;
    font-size: 13px;
    font-weight: bold;
    padding: 5px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    cursor: pointer;
}

.siteTabItem:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.membersHeaderWrapper,
.inspectionsHeaderWrapper,
.actionsHeaderWrapper,
.issuesHeaderWrapper,
.detailsHeaderWrapper {
    display: flex;
    align-items: center;
    width: 100%;
    /* background-color: gray; */
    margin-bottom: 18px;
}

.theLeftBox {
    display: flex;
    width: 50%;
    flex-direction: column;
    justify-content: flex-start;
    /* background-color: yellow; */
    padding-left: 5px;
}

.theRightSide {
    display: flex;
    justify-content: flex-end;
    width: 50%;
    /* background-color: rgb(121, 255, 133); */
}

.titleInput {
    border: 1px solid rgb(197, 197, 197);
}


.viewReportBtn {
    font-size: 14px;
    color: rgb(19, 76, 19);
    cursor: pointer;
    font-weight: bold;
}

.viewReportBtn:hover {
    text-decoration: underline;
    color: rgb(71, 162, 71);
    font-weight: bold;
}

.startInspectionBtn {
    padding-top: 5px;
    padding-bottom: 5px;
    border: none;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    font-size: 12px;
    font-weight: bold;
}

.startInspectionBtn:hover {
    color: green;
}

/* 
.siteBoxWrapper{
    width: 100%;
 
} */


.boxItem {
    display: flex;
    justify-content: space-between;
    width: 70%;
    border-radius: 10px;
    padding: 20px;
    border: 1px #dfeae6 solid;
    margin-bottom: 20px;
}

.theLefty {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* background-color: yellow; */

}


.theRighty {
    display: flex;
    align-items: center;
}


.theNameArea {
    font-size: 18px;
    margin-bottom: 10px;
    width: 100%;
    /* background-color: green; */
    text-align: left;
}

.linkStyle {
    text-decoration: none;
    color: inherit;
}
</style>